import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { useRouter } from 'next/router'

import Button from 'components/Button'

import { addQueryStringParamsToUrl } from 'helpers/params'
import { addProviderToProjectUrl, buildGroupBInquiryUrl } from 'helpers/nexus'
import useHostname from 'hooks/useHostname'
import { usePreselectedFormData } from 'hooks/preselectedFormData'

const InquiryButton = (props) => {
  const intl = useIntl()
  const router = useRouter()
  const hostname = useHostname()
  const currentAgency = useSelector((state) => state.headerData?.currentAgency)
  const isGroupB = useSelector((state) => state.headerData?.experiments?.marketplaceRequestFlow)
  const { isSignedIn, collectionsEnabled } = useSelector((state) => state.currentUser)
  const { preselectedFormData } = usePreselectedFormData()

  // The first client render must match the server's param-less href: React 17
  // does not patch attribute mismatches while hydrating.
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => { setIsMounted(true) }, [])

  const {
    className = '',
    queryParams,
    provider: {
      id,
      isConnectedToMeetingPackage,
      path,
      title,
      type,
    },
    ...restProps
  } = props

  let ctaTranslationKey = `providerProfile.cta.${type}`
  let ctaHref

  if (isConnectedToMeetingPackage) {
    ctaTranslationKey = 'providerProfile.cta.selectRoom'
    ctaHref = '#rooms'
  } else if (isSignedIn && collectionsEnabled && currentAgency?.nexusDomain) {
    ctaTranslationKey = 'providerProfile.cta.EventLocation'
    ctaHref = addProviderToProjectUrl(
      id,
      queryParams?.projectId,
      hostname,
      currentAgency.nexusDomain,
    )
  } else if (isGroupB) {
    // Group B: Route marketplace customers through Nexus project flow
    ctaHref = buildGroupBInquiryUrl(
      id,
      isSignedIn,
      isMounted ? preselectedFormData : {},
      hostname,
      currentAgency?.nexusDomain,
      router?.locale,
    )
  } else {
    ctaHref = addQueryStringParamsToUrl(`${path}/book`, queryParams, { removeEmptyParams: true })
  }

  return (
    <Button
      {...restProps}
      type="primary"
      title={intl.formatMessage(
        { id: 'providerProfilePage.navigationHeader.inquiryButtonTitle' },
        { title },
      )}
      href={ctaHref}
      translationKey={ctaTranslationKey}
      className={classNames('ant-btn--with-border-radius-small', className)}
    />
  )
}

InquiryButton.propTypes = {
  className: PropTypes.number,
  queryParams: PropTypes.shape({
    projectId: PropTypes.number,
  }),
  provider: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isConnectedToMeetingPackage: PropTypes.bool,
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
}

export default InquiryButton
